// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"a4ee76dd","513":"c95afe3e"}[chunkId] + ".chunk.js";
};